import type { CSSProperties, HTMLAttributes, ReactNode } from "react";

type Space = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
type Align = "start" | "center" | "end" | "stretch" | "baseline";
type Justify = "start" | "center" | "end" | "space-between" | "space-around";

export interface InlineProps extends HTMLAttributes<HTMLDivElement> {
  gap?: Space;
  align?: Align;
  justify?: Justify;
  wrap?: boolean;
  children: ReactNode;
}

/**
 * Horizontal layout primitive. Direction-agnostic: relies on the
 * browser's flex algorithm to mirror in RTL automatically.
 */
export function Inline({
  gap = 2,
  align = "center",
  justify = "start",
  wrap = false,
  style,
  children,
  ...rest
}: InlineProps) {
  const computed: CSSProperties = {
    display: "flex",
    flexDirection: "row",
    alignItems:
      align === "baseline" ? "baseline" : align === "stretch" ? "stretch" : `flex-${align}`,
    justifyContent:
      justify === "space-between"
        ? "space-between"
        : justify === "space-around"
          ? "space-around"
          : `flex-${justify}`,
    gap: `var(--gt-sys-space-${gap})`,
    flexWrap: wrap ? "wrap" : "nowrap",
    ...style,
  };
  return (
    <div {...rest} style={computed}>
      {children}
    </div>
  );
}
